import { useLanguage } from "@/lib/i18n";
import { blogScanContent } from "./content";

export function BlogScanReturns() {
  const { language } = useLanguage();
  const c = blogScanContent[language].returns;

  return (
    <section className="py-6">
      <div className="mx-auto max-w-[680px] px-4 sm:px-6">
        <div className="rounded-2xl bg-primary/5 border border-primary/10 px-6 py-8 sm:px-8 sm:py-10">
          <h2 className="font-['Source_Serif_4'] text-2xl md:text-3xl font-semibold text-foreground mb-6">
            {c.title}
          </h2>

          <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
            {c.p1}
          </p>

          <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
            {c.p2}
          </p>

          <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-5">
            {c.p3}
          </p>

          <p className="font-['Source_Serif_4'] text-base md:text-lg leading-[1.8] text-foreground/85 mb-8">
            {c.p4}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <img
              src="/images/blog/scan/scan-2.png"
              alt="Code-barres de retour dans ReFound"
              className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
            />
            <img
              src="/images/blog/scan/scan-4.png"
              alt="Liste des retours dans ReFound"
              className="rounded-2xl shadow-lg max-w-[240px] w-full sm:w-auto mx-auto sm:mx-0"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
